<template>
  <h1>404 / Error</h1>
  <div class="Four0Four">
    Ze route routes U here sinse se page does not seem to egsist.<br />
    Or sere could be anodder problem, alzo.
  </div>
</template>

<script></script>

<style scoped>
.Four0Four {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
